// Module
var code = "<div class=\"front-desk flex layout-row\">\r\n    <div ui-view name=\"agenda\" class=\"flex layout-row\"></div>\r\n    <div ui-view name=\"practice\" class=\"flex-30 layout-row\" mn-acl='{\"action\": \"get\", \"resource\": \"entry\"}'></div>\r\n</div>\r\n";
// Exports
module.exports = code;